import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import JoditEditor from "jodit-react";

export default function TestimonialUpdate() {
  const navigate = useNavigate();
  const editor = useRef(null);
  const { testimonialid } = useParams();
  const [imageFile, setImageFile] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    name_bio: "",
    category: "",
    image: "",
    testimonial: "",
    isactive: false,
    sequence: "",
  });

  const callApiTestimonialList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}testimonials/fetchtestimonials_byid/${testimonialid}`
      );
      setFormData(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (testimonialid) {
      callApiTestimonialList();
    }
  }, [testimonialid]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
    }
  };

  const handleEditorChange = (newContent) => {
    setFormData((prevData) => ({ ...prevData, testimonial: newContent }));
  };

  const callApiUpdateTestimonial = async () => {
    try {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("name_bio", formData.name_bio);
      data.append("category", formData.category);
      data.append("testimonial", formData.testimonial);
      data.append("isactive", formData.isactive);
      data.append("sequence", formData.sequence);

      if (imageFile) {
      data.append("image", imageFile);
    }

      await axios.put(
        `${process.env.REACT_APP_API_URL}testimonials/updatetestimonial/${testimonialid}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    } catch (err) {
      console.error(err);
      toast.error("Failed to update testimonial.", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowConfirmModal(true);
  };

  const handleConfirmUpdate = async () => {
    setShowConfirmModal(false);
    await callApiUpdateTestimonial();
    toast.success("Testimonial updated successfully.", {
      position: "top-right",
      autoClose: 1000,
      theme: "colored",
    });
    setTimeout(() => {
      navigate("/testimonialsList");
    }, 2000);
  };

  return (
    <>
      <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            Update Testimonial
          </div>
          <div className="form-card-body">
            <form onSubmit={handleSubmit}>

              {/* Row 1: Sr No & ID */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="srno" className="form-label">Sr. No:</label>
                  <input type="number" name="srno" className="form-control" value={formData.srno || ""} disabled />
                </div>
                <div className="col-md-6">
                  <label htmlFor="testimonialid" className="form-label">Testimonial ID:</label>
                  <input type="number" name="testimonialid" className="form-control" value={formData.testimonialid || ""} disabled />
                </div>
              </div>

              {/* Row 2: Name & Name Bio */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="name" className="form-label">Name:</label>
                  <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange} placeholder="Name" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="name_bio" className="form-label">Name Bio:</label>
                  <input type="text" name="name_bio" className="form-control" value={formData.name_bio} onChange={handleChange} placeholder="Name Bio" />
                </div>
              </div>

              {/* Row 3: Category & Image */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="category" className="form-label">Category:</label>
                  <input type="text" name="category" className="form-control" value={formData.category} onChange={handleChange} placeholder="Category" />
                </div>
                <div className="col-md-6">
                  <label htmlFor="image" className="form-label">Image:</label>
                  <input type="text" name="image" className="form-control" value={formData.image} onChange={handleChange} />
                  <input type="file" name="imageFile" className="form-control mt-2" onChange={handleFileChange} />
                  {formData.image && (
                    <div className="image-preview-container">
                      <img
                        src={formData.image.startsWith('http') ? formData.image : `${process.env.REACT_APP_API_URL}${formData.image.replace(/\\/g, '/')}`}
                        alt="Current"
                        loading="lazy"
                        className="image-preview"
                      />
                      <span className="image-preview-label">Current image</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Row 4: Sequence */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="sequence" className="form-label">Sequence:</label>
                  <input type="number" name="sequence" className="form-control" value={formData.sequence} onChange={handleChange} placeholder="Sequence" />
                </div>
              </div>

              {/* Testimonial Editor */}
              <div className="mb-3">
                <label htmlFor="testimonial" className="form-label">Testimonial:</label>
                <JoditEditor
                  ref={editor}
                  value={formData.testimonial}
                  name="testimonial"
                  id="testimonial"
                  className="form-control"
                  onChange={(newContent) => {
                  if (newContent !== formData.testimonial) {
                    handleEditorChange(newContent);
                  }
                }}
                />
              </div>

              {/* Toggle Switch for Is Active */}
              <div className="toggle-switch">
                <input
                  type="checkbox"
                  name="isactive"
                  checked={formData.isactive == 1}
                  onChange={(e) =>
                    setFormData((prevData) => ({
                      ...prevData,
                      isactive: e.target.checked ? 1 : 0,
                    }))
                  }
                />
                <span className="toggle-switch-label">Is Active</span>
              </div>

              {/* Form Actions */}
              <div className="form-actions">
                <button type="submit" className="btn-gradient-primary">
                  Update Testimonial
                </button>
                <Link to="/testimonialsList" className="btn-back-link">
                  ← Back to List
                </Link>
              </div>

            </form>
          </div>
        </div>
      </div>

      {/* Update Confirmation Modal */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to update this testimonial?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer />
    </>
  );
}